import { Component, OnDestroy, OnInit, TemplateRef, ViewEncapsulation} from '@angular/core';
import { HcModal, HcTableDataSource, ModalOptions, ModalService, SimpleModalOptions } from '@healthcatalyst/cashmere';
import { KeyElement, KeyService } from '../shared/services/key.service';
import { Subject, filter, take, takeUntil } from 'rxjs';
import { FormControl, Validators } from '@angular/forms';
import { OktaService } from '../shared/services/okta.service';

/** Public facing API documentation  */
@Component({
    selector: 'pd-api',
    templateUrl: './api.component.html',
    styleUrls: ['./api.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ApiComponent implements OnInit, OnDestroy {
    private unsubscribe = new Subject<void>();
    apiDisplayedColumns: string[] = ['name', 'value', 'date', 'actions'];
    apiDataSource: HcTableDataSource<KeyElement> = new HcTableDataSource();
    loading = true;
    loadError = false;
    apiKeyName = new FormControl('', {nonNullable: true, validators: [Validators.required]});
    modalRef: HcModal<TemplateRef<any>>;

    constructor ( private keyService: KeyService, private modalService: ModalService, private oktaService: OktaService ) {}

    ngOnInit(): void {
        this.oktaService.superAdminUpdated.pipe(takeUntil(this.unsubscribe)).subscribe(adminVal => {
            if ( adminVal !== null ) {
                this.keyService.keyListUpdated.pipe(takeUntil(this.unsubscribe)).subscribe(list => {
                    if (list) {
                        this.loading = false;
                        this.loadError = false;
                        this.apiDataSource = new HcTableDataSource(list);
                    } else {
                        this.loadError = this.keyService.loadFailed;
                        if (!this.loadError) {
                            this.keyService.refresh(false);
                        } else {
                            this.loading = false;
                        }
                    }
                });
            }
        });
    }

    addKey(content: TemplateRef<any>): void {
        const options: ModalOptions = {
            size: 'md',
            closeIcon: true,
            data: {
                edit: false,
                element: null
            }
        };
        this.apiKeyName.patchValue('');
        this.modalRef = this.modalService.open(content, options);
    }

    addSave(): void {
        this.keyService.add( {
            keyID: 0,
            name: this.apiKeyName.value,
            username: this.oktaService.username.value,
            date: new Date().toISOString(),
            value: ''
        }, false );
        this.modalRef.close();
    }

    editKey(content: TemplateRef<any>, element: KeyElement): void {
        const options: ModalOptions = {
            size: 'md',
            closeIcon: true,
            data: {
                edit: true,
                element: element
            }
        };
        this.apiKeyName.patchValue(element.name);
        this.modalRef = this.modalService.open(content, options);
    }

    editSave( element: KeyElement ): void {
        element.name = this.apiKeyName.value;
        this.keyService.update( element, false );
        this.modalRef.close();
    }

    removeKey( element: KeyElement ): void {
        const options: SimpleModalOptions = {
            messageHTML: '<p>Are you sure you want to delete the API Key: <strong>' + element.name + '</strong>? This action can not be undone.<p>',
            headerText: 'Delete Key',
            confirmButtonText: 'Delete Key',
            icon: ''
        };
        this.modalService
            .confirmDestructive(options)
            .pipe( take(1), filter(confirmed => confirmed))
            .subscribe(() => {
                this.keyService.remove( element, false );
            });
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
